import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DemoRequestModal from './DemoRequestModal';

const ContactPage: React.FC = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    navigate(-1); // or navigate('/') or navigate('/pricing')
  };

  return (
    <DemoRequestModal
      isOpen={isOpen}
      onClose={handleClose}
      requestType="demo"
    />
  );
};

export default ContactPage;
